import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-shift-icon',
  template: `
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_17784_468)">
        <path
          d="M26.6667 4H6.66667C5.2 4 4 5.2 4 6.66667V25.3333C4 26.8 5.2 28 6.66667 28H26.6667C28.1333 28 29.3333 26.8 29.3333 25.3333V6.66667C29.3333 5.2 28.1333 4 26.6667 4ZM26.6667 6.66667V10.6667H6.66667V6.66667H26.6667ZM20 25.3333H13.3333V13.3333H20V25.3333ZM6.66667 13.3333H10.6667V25.3333H6.66667V13.3333ZM22.6667 25.3333V13.3333H26.6667V25.3333H22.6667Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17784_468">
          <rect width="32" height="32" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShiftIconComponent {}
